/**
* Stepped Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Stepped Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'stepped-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.stepped-content' ).each( function( key, component ) {
        const comp = $( component );
        ScrollTrigger.matchMedia( {
          '(min-width: 1024px)': () => {
            let navHeight = $( '.navbar' ).outerHeight();
            if ( $( '#wpadminbar' ).length ) {
              navHeight += $( '#wpadminbar' ).outerHeight();
            }

            const contentBlocksArray = $( '.stepped-content__content-block' );
            const content = $( '.stepped-content__content' );

            const imagePinner = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                start: ( $( this ).find( '.stepped-content__images .stepped-content__image' ).first().outerHeight() / 2 ) + ' ' + ( navHeight + ( window.innerHeight - navHeight ) / 2 ),
                end: `top ${navHeight}`,
                endTrigger: () =>$( contentBlocksArray[contentBlocksArray.length - 1] ),
                pin: $( this ).find( '.stepped-content__images' ),
                pinSpacing: false,
                // markers: true,
              },
            } );

            $( this ).find( '.stepped-content__content-block' ).each( function( index, element ) {
              const step = $( this ).data( 'step' );
              const image = comp.find( `.stepped-content-image-${step}` );

              const numCounter = gsap.timeline( {
                scrollTrigger: {
                  trigger: this,
                  start: '20% 80%',
                  end: '60% 50%',
                  scrub: 0.15,
                  // markers: true,
                  onRefresh: ( self ) => {
                  },
                  onEnter: ( {progress, direction, isActive} ) => {
                    const oldContent = step - 1;
                    if ( step > 1 ) {
                      comp.find( `#stepped-content-${step}-num` ).removeClass( 'hidden' );
                      comp.find( `#stepped-content-${oldContent}-num` ).addClass( 'hidden' );
                    }
                    comp.find( `.stepped-content-num:not(#stepped-content-${step}-num)` ).addClass( 'hidden' );
                  },
                  onEnterBack: ( {progress, direction, isActive} ) => {
                    const oldContent = step + 1;
                    if ( step !== contentBlocksArray.length ) {
                      comp.find( `#stepped-content-${step}-num` ).removeClass( 'hidden' );
                      comp.find( `#stepped-content-${oldContent}-num` ).addClass( 'hidden' );
                    }
                    comp.find( `.stepped-content-num:not(#stepped-content-${step}-num)` ).addClass( 'hidden' );
                  },
                },
              } );

              const contentFader = gsap.timeline( {
                scrollTrigger: {
                  trigger: this,
                  start: 'top 75%',
                  end: 'top 60%',
                  endTrigger: $( this ).find( '.stepped-content__title' ),
                  scrub: true,
                  // markers: true,
                },
              } );
              contentFader.to( this, {opacity: '1', ease: 'linear'} );

              const imageReveal = gsap.timeline( {
                scrollTrigger: {
                  trigger: this,
                  start: 'top 90%',
                  end: 'top center',
                  scrub: 0.15,
                  // markers: true,
                },
              } );

              imageReveal.to( image, {clipPath: 'polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)', ease: 'linear'}, 0 );
              imageReveal.to( image, {scale: '1.2', ease: 'linear'}, 0 );
            } );
          },
          '(max-width: 1024px)': () => {
            gsap.set( '.stepped-content__content-block', {opacity: 1} );
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'stepped-content', COMPONENT );
} )( app );
